export const navLinks = [
  { id: "home", name: "Home", href: "#home" },
  { id: "benefits", name: "Explore", href: "#benefits" },
  { id: "about", name: "About", href: "#about" },
  { id: "menu", name: "Menu", href: "#menu" },
  { id: "contact", name: "Contact", href: "#contact" },
] as const;

export type NavLinkId = (typeof navLinks)[number]["id"];
